import ChildrenCategoriesTypeEnum from 'Rentlio/utils/childrenCategoriesEnum'
import ChildrenCategoryDerivationType from 'Rentlio/utils/childrenCategoryDerivationTypeEnum'

/** Total value for all nights **/
const getPPPDChildrenPrice = (categories, priceForSingleAdultNight, nights) => {
  if (!categories) {
    return 0
  }

  let priceForChildren = 0

  categories.map(category => {
    switch (category.type) {
      case ChildrenCategoriesTypeEnum.AS_ADULT:
        priceForChildren = priceForChildren + priceForSingleAdultNight * nights
        break
      case ChildrenCategoriesTypeEnum.CUSTOM: {
        if (!category.percentageValue && !category.nominalValue) {
          break
        }
        const priceForChild =
          category.valueType === ChildrenCategoryDerivationType.PERCENTAGE
            ? (+category.percentageValue / 100) * priceForSingleAdultNight
            : +category.nominalValue
        priceForChildren = priceForChildren + priceForChild * nights
        break
      }
      case ChildrenCategoriesTypeEnum.MANUAL:
        priceForChildren += category.nominalValue * nights
        break
    }
  })

  return priceForChildren
}

export default getPPPDChildrenPrice
